/**
 * Constantes del componente ProgressCircleIndeterminate.
 * Definidas en su propio fichero (convención del repo).
 */
import type { ProgressCircleIndeterminateSize } from './types'

/** Tamaño por defecto del spinner. */
export const DEFAULT_SIZE: ProgressCircleIndeterminateSize = 'm'

/** Texto accesible por defecto (visualmente oculto). */
export const DEFAULT_LABEL = 'Cargando'

/**
 * Diámetro en px por tamaño. El DS Entradas no define tokens `--size-*`
 * para spinners, por lo que la geometría del SVG (dimensión dirigida por
 * prop) se aplica como atributo/inline, igual que en ProgressBar/Skeleton.
 */
export const SIZE_MAP: Record<ProgressCircleIndeterminateSize, number> = {
  xl: 64,
  l: 48,
  m: 40,
  s: 32,
}

/**
 * Grosor del trazo (px). No existe token de DS adecuado: el más cercano,
 * `--border-width-emphasis` (2px), resulta demasiado fino para un anillo
 * visible. Se mantiene 3px como constante geométrica del componente.
 */
export const STROKE_WIDTH = 3

/** Fracción de la circunferencia que dibuja el arco visible (~75%). */
export const ARC_FRACTION = 0.75
